// extracted by mini-css-extract-plugin
export default {"tokenInfo":"styles_tokenInfo__r2WHF","token":"styles_token__N3d4b","tokenName":"styles_tokenName__4a1RL"};